export default __webpack_public_path__ + "static/media/room-12.7dee4920.jpg";